/* main entry point for the React application */
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import GlobalTitle from './GlobalTitle';
import Navbar from './components/naviagation/Navbar';
import Home from './pages/Home';
import About from './pages/About';
import Expertise from './pages/Expertise';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import ErrorPage from './pages/ErrorPage';
import Footer from './components/naviagation/Footer';

function App() {
  return (
    <Router>
      <GlobalTitle />
      <Navbar/>
      <Routes>
        {/* Define your routes here */}
        <Route path="/*" element={<ErrorPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/expertise" element={<Expertise />} />
        <Route path="/" element={<Home />} />
        <Route path="/portfolio" element={<Portfolio />} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
